export { default } from './ConsentOverlay';
